import { getLocale, t, useStoreLanguage } from "../../../features/store-language/i18n.ts";
import { PendingRing } from "../../shared/LoadingRing.jsx";
import "../../../utils/quantity-button/InputNumber.css";
import "./CatalogOrderControls.css";

export default function CatalogOrderQuantity({ quantity, pending, disabled, unavailable, label, onChange }: {
  quantity: number;
  pending: boolean;
  disabled: boolean;
  unavailable?: boolean;
  label: string;
  onChange: (delta: number) => Promise<void>;
}) {
  const language = useStoreLanguage();
  const formattedQuantity = new Intl.NumberFormat(getLocale(), {
    numberingSystem: language === "fa" ? "arabext" : language === "ar" ? "arab" : "latn",
    useGrouping: false,
  }).format(quantity);
  return (
    <fieldset
      data-quantity=""
      className="catalog-order-quantity"
      role="group"
      aria-label={t("تعداد {{label}} در سفارش جاری", { label })}
      aria-busy={pending}
    >
      <button
        type="button"
        className="sub"
        disabled={disabled || pending || quantity <= 0}
        aria-label={t("کاهش تعداد {{label}}", { label })}
        onClick={function () { return onChange(-1); }}
      >
        {t("کاهش")}
      </button>
      <input
        type="text"
        value={formattedQuantity}
        readOnly
        disabled={disabled || pending}
        aria-label={t("تعداد {{label}} در سفارش جاری", { label })}
      />
      {pending ? (
        <span className="catalog-order-quantity__pending">
          <PendingRing />
        </span>
      ) : null}
      <button
        type="button"
        className="add"
        disabled={disabled || pending || unavailable || quantity >= 100000}
        aria-label={t("افزودن {{label}} به سفارش جاری", { label })}
        onClick={function () { return onChange(1); }}
      >
        {t("افزودن")}
      </button>
    </fieldset>
  );
}
